import React, { useState,useEffect } from 'react';
import { useLocation,useNavigate} from 'react-router-dom';


function TeacherInfo() {
  const [education, setEducation] = useState('');
  const [position, setPosition] = useState('');
  const [appointment, setAppointment] = useState('');
  const [payscale, setPayScale] = useState('');
  const [eligibility, setEligibility] = useState('');
  const [manyata, setManyata] = useState('');
  const [basicsalary, setBasicSalary] = useState('');
  const [retiredate, setRetiredDate] = useState('');
  const [schoolid, setSchoolId] = useState('');
  const [aadharnumber, setAadharNumber] = useState('');
  const [pannumber, setPancardNumber] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const adminmob = queryParams.get('adminmob');
    const branchId = queryParams.get('branchId');
    const empmobile = queryParams.get('empmobile');
        const [language, setLanguage] = useState(
          localStorage.getItem("language") || "English"
        );
        const udiseNumber= localStorage.getItem("udiseNumber")
  console.log("adminmob",adminmob);
  
// start?

  // Fetch bank details from Firebase when the component mounts
  useEffect(() => {
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/TeacherDetails.json`;
    
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch teacher details');
        }
        return response.json();
      })
      .then(data => {
        if (data) {
          setEducation(data.education || '');
          setPosition(data.position || '');
          setAppointment(data.appointment || '');
          setPayScale(data.payscale || '');
          setEligibility(data.eligibility || '');
          setManyata(data.manyata || '');
          setBasicSalary(data.basicsalary || '');
          setRetiredDate(data.retiredate || '');
          setSchoolId(data.schoolid || '');
          setAadharNumber(data.aadharnumber || '');
          setPancardNumber(data.pancardnumber || '');
        }
      })
      .catch(error => {
        console.error("Error fetching teacher details: ", error);
      });
  }, [udiseNumber, empmobile]);

  const handlesave = (event) => {
    event.preventDefault();
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/TeacherDetails.json`;
    
    const updatedData = {
      education: education,
      position: position,
      appointment: appointment,
      payscale: payscale,
      eligibility: eligibility,
      manyata: manyata,
      basicsalary: basicsalary,
      retiredate: retiredate,
      schoolid: schoolid,
      aadharnumber: aadharnumber,
      pancardnumber: pannumber,
    };

    fetch(url, {
      method: 'PUT', // PUT will replace the existing data completely
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedData),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to save teacher details');
        }
        return response.json();
      })
      .then(() => {
        console.log('Teacher details updated successfully');
        alert('Teacher details updated successfully');
        // Optional: Add success message or navigation here
      })
      .catch(error => {
        console.error('Error saving teacher details:', error);
      });
  };

  const handleClose = () => {
    navigate(-1); // Change '/profile' to the actual path of your profile page
};


  return (
    <div className='main-content-of-page'>
      <div className='teacher-info-form' style={{
        border: '2px solid black',
        margin: 'auto',
        width: '70%',
        height: '580px',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        marginTop:"60px"
      }}>
       <button style={{ 
                            backgroundColor: '#dc3545', 
                            color: '#fff', 
                            border: 'none', 
                            borderRadius: '5px', 
                            cursor: 'pointer', 
                            fontSize: '20px', 
                            marginLeft: '1045px',
                            marginBottom:'10px',
                            fontWeight:'bold', 
                        }} onClick={handleClose}> 
                           X
                        </button>
                        <h2 style={{
  textAlign: 'center',
  marginBottom: '20px',
  fontSize: '24px',
  fontWeight: 'bold'
}}>{language === "English" ? "Other Employement Record" : "इतर रोजगार माहिती"}</h2>
<form onSubmit={handlesave}>
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px'
  }}>
    <div style={{
      width: '30%',
      marginRight: '10px'
    }}>
      <label style={{
        display: 'block',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>{language === "English" ? " Education: " : "शिक्षण"}</label>
      <input
        type='text'
        value={education}
        onChange={(e) => setEducation(e.target.value)}
        placeholder='Enter your education'
        style={{
          width: '100%',
          height: '40px',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '5px',
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = '#007bff';
          e.target.style.boxShadow = '0 0 5px rgba(0, 123, 255, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = 'black';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
    <div style={{
      width: '30%',
      marginRight: '10px'
    }}>
      <label style={{
        display: 'block',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>{language === "English" ? "Designation: " : "पद"}</label>
      <input
        type='text'
        value={position}
        onChange={(e) => setPosition(e.target.value)}
        placeholder='Enter your position'
        style={{
          width: '100%',
          height: '40px',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '5px',
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = '#007bff';
          e.target.style.boxShadow = '0 0 5px rgba(0, 123, 255, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = 'black';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
    <div style={{
      width: '30%'
    }}>
      <label style={{
        display: 'block',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>{language === "English" ? "First appointment: " : "प्रथम नेमणूक"}</label>
      <input
        type='date'
        value={appointment}
        onChange={(e) => setAppointment(e.target.value)}
        style={{
          width: '100%',
          height: '40px',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '5px',
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = '#007bff';
          e.target.style.boxShadow = '0 0 5px rgba(0, 123, 255, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = 'black';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
  </div>
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px'
  }}>
    <div style={{
      width: '30%',
      marginRight: '10px'
    }}>
      <label style={{
        display: 'block',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>{language === "English" ? "pay scale: " : "वेतनश्रेणी"}</label>
      <input
        type='number'
        value={payscale}
        onChange={(e) => {
    // Ensure that the input doesn't exceed 8 digits
    if (e.target.value.length <= 8) {
      setPayScale(e.target.value);
    }
  }}
        style={{
          width: '100%',
          height: '40px',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '5px',
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = '#007bff';
          e.target.style.boxShadow = '0 0 5px rgba(0, 123, 255, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = 'black';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
    <div style={{
      width: '30%',
      marginRight: '10px'
    }}>
      <label style={{
        display: 'block',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>{language === "English" ? "Eligibility: " : "पात्रता"}</label>
      <input
        type='text'
        value={eligibility}
        onChange={(e) => setEligibility(e.target.value)}
        style={{
          width: '100%',
          height: '40px',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '5px',
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = '#007bff';
          e.target.style.boxShadow = '0 0 5px rgba(0, 123, 255, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = 'black';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
    <div style={{
      width: '30%'
    }}>
      <label style={{
        display: 'block',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>{language === "English" ? "Type of approval: " : "मान्यतेचा प्रकार"}</label>
      <input
        type='text'
        value={manyata}
        onChange={(e) => setManyata(e.target.value)}
        style={{
          width: '100%',
          height: '40px',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '5px',
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = '#007bff';
          e.target.style.boxShadow = '0 0 5px rgba(0, 123, 255, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = 'black';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
  </div>
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px'
  }}>
    <div style={{
      width: '30%',
      marginRight: '10px'
    }}>
      <label style={{
        display: 'block',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>{language === "English" ? "Current Basic Salary " : "सध्याचे मूळ वेतन"}</label>
      <input
        type='number'
        value={basicsalary}
        onChange={(e) => {
          if (e.target.value.length <= 8){
          setBasicSalary(e.target.value);
        }
        }}
        style={{
          width: '100%',
          height: '40px',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '5px',
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = '#007bff';
          e.target.style.boxShadow = '0 0 5px rgba(0, 123, 255, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = 'black';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
    
    <div style={{
      width: '30%'
    }}>
      <label style={{
        display: 'block',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>{language === "English" ? "Retirement date " : "निवृत्तीची तारीख"}</label>
      <input
        type='date'
        value={retiredate}
        onChange={(e) => setRetiredDate(e.target.value)}
        style={{
          width: '100%',
          height: '40px',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '5px',
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = '#007bff';
          e.target.style.boxShadow = '0 0 5px rgba(0, 123, 255, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = 'black';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>

    <div style={{
      width: '30%'
    }}>
      <label style={{
        display: 'block',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>{language === "English" ? "School ID " : "शाळेची आयडी"}</label>
      <input
        type='number'
        value={schoolid}
        onChange={(e) => {
    if (e.target.value.length <= 6) {
      setSchoolId(e.target.value);
    }
  }}
        style={{
          width: '100%',
          height: '40px',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '5px',
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = '#007bff';
          e.target.style.boxShadow = '0 0 5px rgba(0, 123, 255, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = 'black';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
  </div>
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px'
  }}>
    <div style={{
      width: '30%',
      marginRight: '10px'
    }}>
      <label style={{
        display: 'block',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>{language === "English" ? "Aadhar Card Number " : "आधार कार्ड क्रमांक"}</label>
      <input
        type='number'
        value={aadharnumber}
        onChange={(e) => {
    // Only allow the input if the length is 12 or less
    if (e.target.value.length <= 12) {
      setAadharNumber(e.target.value);
    }
  }}
        style={{
          width: '100%',
          height: '40px',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '5px',
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = '#007bff';
          e.target.style.boxShadow = '0 0 5px rgba(0, 123, 255, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = 'black';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
    <div style={{
      width: '30%',
      marginRight: '10px'
    }}>
      <label style={{
        display: 'block',
        marginBottom: '10px',
        fontWeight: 'bold'
      }}>{language === "English" ? "Pan card Number " : "पॅन कार्ड क्रमांक"}</label>
      <input
        type='text'
        value={pannumber}
        onChange={(e) => {
    const value = e.target.value.toUpperCase(); // Ensure that the input is always in uppercase

    // Remove any invalid characters (non-alphanumeric) from the input
    const allowedValue = value.replace(/[^A-Z0-9]/g, ''); // Removes anything that's not a letter or digit

    // Ensure that the input strictly follows the PAN number format
    if (/^[A-Z]{0,5}\d{0,4}[A-Z]{0,1}$/.test(allowedValue) && allowedValue.length <= 10) {
      setPancardNumber(allowedValue); // Update the state with the valid value
    }
  }}
        style={{
          width: '100%',
          height: '40px',
          padding: '10px',
          border: '1px solid black',
          borderRadius: '5px',
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e .target.style.borderColor = '#007bff';
          e.target.style.boxShadow = '0 0 5px rgba(0, 123, 255, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = 'black';
          e.target.style.boxShadow = 'none';
        }}
      />
    </div>
  </div>
          <div style={{
            textAlign: 'center'
          }}>
            <button type="save" style={{
              marginRight: '10px',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '5px',
              backgroundColor: '#03365e',
              color: 'white',
              cursor: 'pointer',
              marginTop:'10px'
            }}>Save</button>

          </div>
        </form>
      </div>
    </div>
  );
}

export default TeacherInfo;